import React from 'react';
import SitemapGeneratorDashboard from '@/components/seo/SitemapGeneratorDashboard';
import { Helmet } from 'react-helmet-async';

const SitemapGenerator: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Sitemap Generator - Global Therapy Hub</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <SitemapGeneratorDashboard />
    </>
  );
};

export default SitemapGenerator;
